import { z } from 'zod';
// ─── Event Types ─────────────────────────────────────────────────────────────
export const createEventTypeSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    description: z.string().max(1000).optional(),
});
export const updateEventTypeSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    description: z.string().max(1000).nullable().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
// ─── Vendor Categories ───────────────────────────────────────────────────────
export const createVendorCategorySchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
});
export const updateVendorCategorySchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
// ─── Expense Statuses ────────────────────────────────────────────────────────
export const createExpenseStatusSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    color: z
        .string()
        .max(7)
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .optional(),
    sortOrder: z.number().int().optional(),
    isPaidInFull: z.boolean().optional(),
});
export const updateExpenseStatusSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    color: z
        .string()
        .max(7)
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .nullable()
        .optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
    isPaidInFull: z.boolean().optional(),
});
// ─── Payment Methods ─────────────────────────────────────────────────────────
export const createPaymentMethodSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    isProducerFunded: z.boolean().optional(),
});
export const updatePaymentMethodSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    isActive: z.boolean().optional(),
    isProducerFunded: z.boolean().optional(),
});
//# sourceMappingURL=settings.js.map